module.exports = __webpack_public_path__ + "img/122.92f643e6.jpg";